export enum InvoiceLineType {
  Deposit = 'deposit',
  Description = 'description',
  Row = 'row',
  Subtotal = 'subtotal',
}
